
import React, { useReducer } from "react";
import axios2 from 'services/axios2';

import {useParams} from "react-router-dom";
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import FigureItem  from "components/FigureItem";
import NuCheckbox from "components/nubox/NuCheckbox"
import InputNumber from "components/InputNumber"
import NuDrop  from "components/nubox/NuDrop";
import NuDropCheck  from "components/nubox/NuDropCheck";

import { withRouterJim } from "router/withRouterJim";

//--- CONTEXT API -----------
import { useStore, useDispatch, StoreContext } from "store/StoreProvider";
import {types, storeReducer} from "store/StoreReducer"


import { NotificationContainer, NotificationManager } from 'react-notifications';
import {
  Table,
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  ModalFooter,
  ToastHeader,
} from "reactstrap";

const cbo=[
  {  value:'1', label: 'label1'},
]


const initialForm = {
  idd:0,
  ope:'n',
  
  
  
};

//$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
class TablaNotas extends React.Component {
  state = {

    modalImagen: false,
    
    fecha:'',
    bimestre:0,
    form: Object.assign({}, initialForm),

    dataList: [],/* lista  */
    //{"col":1, "label":'A1', 'id_asisfe':145 }
    options: [  {value:'all', label:'Completo'},
      {value:'e1', label:'E1'},
      {value:'e2', label:'E2'},
      {value:'e3', label:'E3'},
      {value:'e4', label:'E4'},
      {value:'e5', label:'E5'},
      {value:'p1', label:'P1'},
      {value:'p2', label:'P2'},
      {value:'p3', label:'P3'},
      {value:'p4', label:'P4'},
      {value:'p5', label:'P5'},
    ],
    optionSelected:{ value:'all', label:'Completo'},

    optionsSel:[{value:'all', label:'Completo'}],
    optionsSelStr:'all',
  };
   //---------------- CONTEXT API ------------------
    //const store = useStore();
    

  //---------------------------------
  componentDidMount() {
    //--limpiamos el array de prueba
    this.setState({dataList:[]});
    
    
    this.cargar_data();

    const date = new Date();
    const defaultValue = date.toLocaleDateString('en-CA');

    //let id_asisfe = this.props.params.id;

    let bimestre = this.props.params.id;
    this.setState({bimestre: bimestre})
    
  }
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name='?' en cada control
    
    //--- esto lo hacemos porque en vez de utilizar valores true, false
    //--- tenemos que utilizar 1, 0
    if(e.target.type==="checkbox"){

      let res = e.target.checked? 1:0;              
      //------------------------------------------------

      this.setState({
        form:{
          ...this.state.form,
          [e.target.name]: res,
        }
      })
      

    }else{
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    }
  };

  //-------------- cambiamos valor en la tabla
  handleCellChange=(index, columnId, value)=>{
    const newData = [...this.state.dataList]; 
    newData[index][columnId] = value;
    //this.setState({ datalist: newData });
    //solo tenemos que dejar pasar si es numero entero
    
    //console.log(value);
    //if(value===""){
    let newData1 = this.calcular(newData, index);
    
    this.setState({ datalist: newData1 });
    //  return;
    //}    
  }
  //-------------------------
  calcular_totales=(tabla)=>{
    console.log("calcular_todos")
    const newData = [...tabla];
    console.log(newData)

    newData.map(( item, index) =>{
      this.calcular(newData,index )
    })
  }
  //------------------------------------------
  //--- solo calculamos la fila
  calcular=(newData, index)=>{
    const newData1 = [...this.state.dataList];

    let nro_eval = 0;
    let nro_prac = 0;
    //------------calculamos nro de practicas
    //nro_prac = this.contar_nro_prac(newData1);
    //---------------------------------------
    let suma_t =0;
    let e1 = newData[index]['e1'];
    let e2 = newData[index]['e2'];
    let e3 = newData[index]['e3'];
    let e4 = newData[index]['e4'];
    let e5 = newData[index]['e5'];
    
    if(e1!="" && e1!=null){ nro_eval++; suma_t+= parseInt(e1)}
    if(e2!="" && e2!=null){ nro_eval++; suma_t+= parseInt(e2)}
    if(e3!="" && e3!=null){ nro_eval++; suma_t+= parseInt(e3)}
    if(e4!="" && e4!=null){ nro_eval++; suma_t+= parseInt(e4)}
    if(e5!="" && e5!=null){ nro_eval++; suma_t+= parseInt(e5)}
    
    let prom_teo = Math.round (suma_t / nro_eval);
    //--------------lo mismo para las practicas
    let suma_p =0;
    let p1 = newData[index]['p1'];
    let p2 = newData[index]['p2'];
    let p3 = newData[index]['p3'];
    let p4 = newData[index]['p4'];
    let p5 = newData[index]['p5'];
    
    if(p1!="" && p1!=null){ nro_prac++; suma_p+= parseInt(p1)}
    if(p2!="" && p2!=null){ nro_prac++; suma_p+= parseInt(p2)}
    if(p3!="" && p3!=null){ nro_prac++; suma_p+= parseInt(p3)}
    if(p4!="" && p4!=null){ nro_prac++; suma_p+= parseInt(p4)}
    if(p5!="" && p5!=null){ nro_prac++; suma_p+= parseInt(p5)}
    
    let prom_prac=0;
    //--si es 0, hace div por 0
    if(nro_prac!=0){
       prom_prac = Math.round (suma_p / nro_prac)
    }
    if(isNaN(prom_teo)){
      newData[index]["prom_teorico"] = 0;
    }else{
      newData[index]["prom_teorico"] = prom_teo;
    }
    newData[index]["prom_practicas"] = prom_prac;
    
    //newData[index]["valo_cualitativa"] = 0;
    let nota_final = prom_teo + prom_prac;
    if(isNaN(nota_final)){
      newData[index]["nota_final"] = 0;
    }else {
      newData[index]["nota_final"] = nota_final;
    }
    //---calculaos valo_cualitariva
    let cad="";
    if(nota_final==0){  cad=""; }
    if(nota_final>0 && nota_final <=50){  cad="ED"; }
    if(nota_final>=51 && nota_final <=68){  cad="DA"; }
    if(nota_final>68 && nota_final <=84){  cad="DO"; }
    if(nota_final>84 && nota_final <=100){  cad="DP"; }
    if(isNaN(nota_final)){ cad =""  }

    newData[index]["valo_cualitativa"] = cad;

    return newData1;
  }
  
  //-------------------------------------------
  /*
    "id_mate": 20,
    "id_carre": 4,

   */
  cargar_data=()=>{
    console.log("cargar_data")
    //let id_est = this.props.store.user.id_est;
    let id_mate = this.props.store.materia.id_mate;
    let id_peri = this.props.store.user.id_peri;
    let periodo = this.props.store.user.periodo;
    let bimestre = parseInt( this.props.params.id);
    

    let param = { 
      id_mate: id_mate,
      id_peri: id_peri,
      bimestre: bimestre,
    }

    console.log(param)
    axios2.post("tabla_notas_get_list", param)
    .then(res => {
        console.log(res.data)
        if(res.data.tabla.length>0){ 
            this.setState({dataList: res.data.tabla,
              
            });
            this.calcular_totales(res.data.tabla)
            //this.setState({columnsA: res.data.columnsA});
        }else{
          this.setState({dataList: [] });
          
            //NotificationManager.error('No existen datos');
        }
    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
    });
  }
  //-----------------------------------------
  // retorna id_mate, nombre, sigla
  guardar_click=()=>{
    console.log("guardar_click");
    console.log("")
    
    this.save();
  }
  //-------------------------------------
  onClickItemDrop=(item)=>{
    console.log(item)
    this.setState({optionSelected: item})
  }
  //-------------------------------
  onSelectOptionsDC=(items,itemsStr)=>{
    console.log(itemsStr)
    this.setState({optionsSel: items})
    this.setState({optionsSelStr: itemsStr})
  }
  //------------------------------
  //---si el campo tiene valor vacio, lo convierte a 0
  normalizar=(num)=>{
    if(num==="") return 0;
    return num;
  }
  //-----------------------------------
  /*"id_progra": 36498,
    "p1": 0,
    "p2": 0,
    "p3": 0,
    "prom_parciales": 0,
    "practicas": 0,
    "prom_practicas": 0,
    "ex_final": 0,
    "prom_ex_final": 0,
    "nota_final": 0,*/
  /* normalizamos valores antes de enviar a el server */
  tabla_filter=()=>{
    const filteredBooks = [];
    this.state.dataList.forEach(filterValue => {
      filteredBooks.push({ "id_nota":filterValue.id_nota,
                          "e1": filterValue.e1,
                          "e2": filterValue.e2,
                          "e3": filterValue.e3,
                          "e4": filterValue.e4,
                          "e5": filterValue.e5,
                          "prom_teorico": filterValue.prom_teorico,
                          "p1": filterValue.p1,
                          "p2": filterValue.p2 ,
                          "p3": filterValue.p3 ,
                          "p4": filterValue.p4 ,
                          "p5": filterValue.p5 ,
                          "prom_practicas": filterValue.prom_practicas,
                          "valo_cualitativa": filterValue.valo_cualitativa,
                          "nota_final": filterValue.nota_final,
                          "obs": filterValue.nota_final>=61? 'APROBADO': 'REPROBADO',
                          } );
    });
    return filteredBooks;
  }

  //-----------------------------------
  save =() =>{

    let param = { 
    
      tabla:  JSON.stringify( this.tabla_filter() )
      //tabla:  JSON.stringify( this.state.dataList )
    };

    console.log(param);
    
    axios2.post("tabla_notas_store", param)
    .then(res => {
        console.log(res.data);
        if(res.data.exito === 1){ 
            
            NotificationManager.success(res.data.men);  
            //redireccionar
            let bimestre = this.props.params.id;
            this.props.navigate('/tabla_notas_fin/'+ bimestre);       
        }else{
            NotificationManager.error(res.data.men);
            
        }

    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
        
    });
    
  }
  //-------------------------------------
  //------------------------------
  render() {
    let materia = this.props.store.materia
    let user = this.props.store.user
    return(
      <div>
        {/* ---   --- */}
        { 
          //JSON.stringify(this.state.form.cant_teo)
          //JSON.stringify(this.state.optionsSelStr)
        }
        <div className="escritorio center-align p-3">

          <div className="row">
            <div className="col-md-7">
              <h3> PLANILLA DE NOTAS { user.periodo } </h3>
              <Button 
                  className="btn btn-success" 
                  onClick={this.guardar_click  } >
                GUARDAR NOTAS
              </Button>
              
              <p>
                Sigla: { materia.sigla }<br />
                Materia: { materia.nombre } /G { materia.grupo } <br />
                Periodo: { user.periodo } <br />
                Bimestre: { this.state.bimestre } <br />
                { /* Fecha: { this.state.fecha }<br/> */}
                Modo edicion: &nbsp;&nbsp;
                {/*<NuDrop
                  options={this.state.options}
                  value={this.state.optionSelected.value}
                  onClickItem={ this.onClickItemDrop }
                  classBtn="btn"
                  iconBtn="fa fa-cog"
                  styleBtn={{borderStyle: 'none', color: "#444444", fontSize:20}}
                  text=''
                />*/}

                <NuDropCheck
                  options={this.state.options}
                  value={this.state.optionSelected }
                  onSelectOptions={ this.onSelectOptionsDC }
                  //onSelect={this.onSelect} // Function will trigger on select event
                  //onRemove={this.onRemove} // Function will trigger on remove event
                  classBtn="btn"
                  iconBtn="fa fa-chevron-down"
                  styleBtn={{borderStyle: 'none', color: "#444444", fontSize:12}}
                  text=''
                />
              </p>
            </div>

            <div className="col-md-5">
             
            </div>

          </div>

        <table className="tabla_azul  table-striped table-hover ">
          <thead>
            <tr>
              <td colSpan={2}></td>
              <td colSpan={6} className="cell_celeste">TEORICO (30 Pts)</td>
              <td colSpan={6} className="cell_rosado">PRACTICO (70 Pts)</td>
            </tr>
            <tr>
                <th width="80px">Nro</th>
                {/*<th>Nro. Doc.</th>*/}
                <th>Apellidos y Nombres</th>
                <th>Eval 1
                  
                </th>
                <th>Eval 2
                  
                </th>
                <th>Eval 3
                 
                </th>
                <th>Eval 4
                  
                </th>
                <th>Eval 5
                  
                </th>
                <td className="cell_celeste">Prom. Eval.</td>
                <th>Prac 1</th>
                <th>Prac 2</th>
                <th>Prac 3</th>
                <th>Prac 4</th>
                <th>Prac 5</th>
                <td className="cell_rosado">Prom. Pract.</td>
                <th>Val. Cuali.</th>
                <th>Nota Final</th>
            </tr>
          </thead>
          <tbody>
              
              {this.state.dataList.map((item,index) => ( 
                  <tr key={index}>
                    <td>{ index+1 }
                      { /* item.id_progra */}
                    </td>
                    {/*<td>{ item.nro_doc }</td>*/}
                    <td>{ item.nomape_tmp }</td>
                    <td>
                      { (this.state.optionsSelStr.includes('e1') || this.state.optionsSelStr.includes('all'))?
                          <InputNumber
                          type="text" 
                          className='' 
                          inputStyle={{width:50,  textAlign: 'center' }}
                          onChange={(e) => this.handleCellChange(index,"e1", e.target.value)} 
                          value={item.e1} 
                          max={30}
                          min={0}
                        />
                        : <>{item.e1}</>
                      }
                    </td>
                    <td>
                      { (this.state.optionsSelStr.includes('e2') || this.state.optionsSelStr.includes('all'))?
                        <InputNumber
                          type="text" 
                          className='' 
                          inputStyle={{width:50,  textAlign: 'center' }}
                          onChange={(e) => this.handleCellChange(index,"e2", e.target.value)} 
                          value={item.e2} 
                          max={30}
                          min={0}
                        />
                        : <>{item.e2}</>
                      }
                    </td>
                    <td>
                      { (this.state.optionsSelStr.includes('e3') || this.state.optionsSelStr.includes('all'))?
                        <InputNumber
                          type="text" 
                          className='' 
                          inputStyle={{width:50,  textAlign: 'center' }}
                          onChange={(e) => this.handleCellChange(index,"e3", e.target.value)} 
                          value={item.e3} 
                          max={30}
                          min={0}
                        />
                      : <>{item.e3}</>
                      }
                    </td>
                    <td>
                      { (this.state.optionsSelStr.includes('e4') || this.state.optionsSelStr.includes('all'))?
                        <InputNumber
                          type="text" 
                          className='' 
                          inputStyle={{width:50,  textAlign: 'center' }}
                          onChange={(e) => this.handleCellChange(index,"e4", e.target.value)} 
                          value={item.e4} 
                          max={30}
                          min={0}
                        />
                      : <>{item.e4}</>
                      }
                    </td>
                    <td>
                      { (this.state.optionsSelStr.includes('e5') || this.state.optionsSelStr.includes('all'))?
                        <InputNumber
                          type="text" 
                          className='' 
                          inputStyle={{width:50,  textAlign: 'center' }}
                          onChange={(e) => this.handleCellChange(index,"e5", e.target.value)} 
                          value={item.e5} 
                          max={30}
                          min={0}
                        />
                      : <>{item.e5}</>
                      }
                    </td>
                    {/**------------------------------------- */}
                    <td > 
                      <input type="text" 
                        className='' 
                        style={{width:50,  textAlign: 'center' }}
                        onChange={(e) => this.handleCellChange(index,"prom_teorico", e.target.value)} 
                        value={item.prom_teorico} 
                        disabled
                      />
                    </td>
                    {/**------------------------------------- */}
                    <td>
                      { (this.state.optionsSelStr.includes('p1') || this.state.optionsSelStr.includes('all'))?
                        <InputNumber
                          type="text" 
                          className='' 
                          inputStyle={{width:50,  textAlign: 'center' }}
                          onChange={(e) => this.handleCellChange(index,"p1", e.target.value)} 
                          value={item.p1} 
                          max={70}
                          min={0}
                        />
                      : <>{item.p1}</>
                      }
                    </td>
                    <td>
                      { (this.state.optionsSelStr.includes('p2') || this.state.optionsSelStr.includes('all'))?
                        <InputNumber
                          type="text" 
                          className='' 
                          inputStyle={{width:50,  textAlign: 'center' }}
                          onChange={(e) => this.handleCellChange(index,"p2", e.target.value)} 
                          value={item.p2} 
                          max={70}
                          min={0}
                        />
                      : <>{item.p2}</>
                      }
                    </td>
                    <td>
                      { (this.state.optionsSelStr.includes('p3') || this.state.optionsSelStr.includes('all'))?
                        <InputNumber
                          type="text" 
                          className='' 
                          inputStyle={{width:50,  textAlign: 'center' }}
                          onChange={(e) => this.handleCellChange(index,"p3", e.target.value)} 
                          value={item.p3} 
                          max={70}
                          min={0}
                        />
                      : <>{item.p3}</>
                      }
                    </td>
                    <td>
                      { (this.state.optionsSelStr.includes('p4') || this.state.optionsSelStr.includes('all'))?
                      <InputNumber
                        type="text" 
                        className='' 
                        inputStyle={{width:50,  textAlign: 'center' }}
                        onChange={(e) => this.handleCellChange(index,"p4", e.target.value)} 
                        value={item.p4} 
                        max={70}
                        min={0}
                      />
                      : <>{item.p4}</>
                      }
                    </td>
                    <td>
                      { (this.state.optionsSelStr.includes('p5') || this.state.optionsSelStr.includes('all'))?
                        <InputNumber
                          type="text" 
                          className='' 
                          inputStyle={{width:50,  textAlign: 'center' }}
                          onChange={(e) => this.handleCellChange(index,"p5", e.target.value)} 
                          value={item.p5} 
                          max={70}
                          min={0}
                        />
                      : <>{item.p5}</>
                      }
                    </td>
                    {/**------------------------------------- */}
                    <td > 
                      <input type="text" 
                        className='' 
                        style={{width:50,  textAlign: 'center' }}
                        onChange={(e) => this.handleCellChange(index,"prom_practicas", e.target.value)} 
                        value={item.prom_practicas} 
                        disabled
                      />
                    </td>
                    {/**------------------------------------- */}
                    {/**------------------------------------- */}
                    <td > 
                      <input type="text" 
                        className='' 
                        style={{width:50,  textAlign: 'center' }}
                        onChange={(e) => this.handleCellChange(index,"valo_cualitativa", e.target.value)} 
                        value={item.valo_cualitativa} 
                        disabled
                      />
                    </td>
                    {/**------------------------------------- */}
                    <td > 
                      <input type="text" 
                        className='' 
                        style={{width:50,  textAlign: 'center' }}
                        onChange={(e) => this.handleCellChange(index,"nota_final", e.target.value)} 
                        value={item.nota_final} 
                        disabled
                      />
                    </td>
                                  
                  </tr>
              ))}
              
          </tbody>
        </table>

        <div className="pt-2">
          {/*
          <table width="80%" align="center" >
            <tbody>
              <tr>
                <td align="center">
                  <Button className="btn btn-success"
                          onClick={this.guardar_click  } >
                  GUARDAR NOTAS</Button>
                </td>
              </tr>
            </tbody>
          </table>
           */}
        </div>


      </div>
        

        <NotificationContainer/>
      </div>
    )
  }
}

//------------para que soporte la funcionalidad de parametros
export default withRouterJim(TablaNotas);